export default __webpack_public_path__ + "static/media/iconregalo.f6e6ac06.svg";